// Module
var code = `<form novalidate name="\$ctrl.form">
  <div class="form-column">
    <form-section form-title="'Schedule'">
      <form-section-field field-title="'Collection payment interval'">
        <select ng-options="type.value as type.label for type in \$ctrl.paymentIntervals"
          ng-model="\$ctrl.profile.collectionPaymentInterval"
          required>
        </select>
      </form-section-field>

      <form-section-field field-title="'Day'">
        <day-of-week include-weekend="true" value="\$ctrl.profile.collectionDay" required="true">
        </day-of-week>
      </form-section-field>

      <form-section-field field-title="'Group Collection Date Started'">
        <date output-format="date"
              ng-model="\$ctrl.profile.collectionStartDate"
              init-with-null="true"
              ng-required="\$ctrl.propertyConfigService.required('customer', 'group', 'collection_start_date')"></date>
      </form-section-field>

      <form-section-field field-title="'Time from'">
        <input
          required
          type="time"
          ng-model="\$ctrl.profile.collectionTimeFrom"/>
      </form-section-field>

      <form-section-field field-title="'Time to'">
        <input
          required
          type="time"
          ng-model="\$ctrl.profile.collectionTimeTo"
          ng-min="\$ctrl.profile.collectionTimeFrom"
        />
      </form-section-field>
    </form-section>
  </div>


  <div class="clearfix"></div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/group-loans/profile/sub-components/group-schedule.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;